import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Martín', 'Sofía', 'Lucía', 'Joaquín', 'Camila', 'Tomás', 'Florencia', 'Agustín', 'Valentina', 'Mateo', 'Julieta', 'Federico', 'Mariana', 'Diego', 'Paula'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'Bariloche', 'Paraná', 'Santa Fe', 'Resistencia', 'Posadas'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      // Hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
      // Schedule next popup between 15 and 25 seconds
      const nextDelay = Math.floor(Math.random() * (25000 - 15000 + 1)) + 15000;
      timeoutId = setTimeout(showPopup, nextDelay);
    };
    // Initial delay of 5 seconds
    timeoutId = setTimeout(showPopup, 5000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <AnimatePresence data-id="element-119">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 flex max-w-[320px] items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 shadow-xl sm:bottom-8 sm:left-8" data-id="element-120">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-100" data-id="element-121">
            <CheckCircle2 className="h-6 w-6 text-emerald-600" data-id="element-122" />
          </div>
          <div data-id="element-123">
            <p className="text-sm font-medium text-slate-800" data-id="element-124">
              <span className="font-bold" data-id="element-125">{purchaseData.name}</span> de{' '}
              {purchaseData.city} acaba de comprar el KIT
            </p>
            <p className="text-xs text-slate-500" data-id="element-126">
              hace {purchaseData.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}